import React from 'react';
import { PageContainer } from 'components/page-container';

export const DashboardScreen = () => {
  return <PageContainer></PageContainer>;
};
